/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  height: 48px;
  background-color: ${Palette.PrimaryGray._000};
`;

export const Section = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: 1px solid ${Palette.PrimaryGray._200};
  padding: 0 16px;
  span {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: ${({ field }) => field === 'include' && `${Palette.Teal._600}`};
    color: ${({ field }) => field === 'exclude' && `${Palette.Red._600}`};
    align-self: center;
  }
`;
